"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerBffClient = void 0;
const envConfig_1 = require("../config/envConfig");
const httpClient_1 = require("./httpClient");
exports.customerBffClient = (0, httpClient_1.createHttpClient)({
    baseURL: envConfig_1.envConfig.customerBffUrl,
});
